export const BUNDLE_URL_PARAM = 'psbundles'
export const ENRICHED_BUNDLE_URL_PARAM = 'epsb'
export const SAMPLE_PARAM = 'colors'
